var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 98.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "peak") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.47,6.67C93-5.46,94.32,18.54,111.53,3.56V28c-16.42,14.77-20-9.1-36.06,3V6.67Zm47.41,91.85H28.76L54.63,57.63,71.27,70.18a2.83,2.83,0,0,0,3.64-.2L90.75,56.43l32.13,42.09ZM57.65,52.85l12-19V6.23h.16A3.35,3.35,0,0,1,71.5,0h0a3.35,3.35,0,0,1,1.71,6.23h.16V33.66L87.33,52,72.86,64.31,57.65,52.85ZM0,98.52l29.41-49a2.69,2.69,0,0,1,.9-.94,2.66,2.66,0,0,1,3.66.85c2.7,4.31,5.34,8.08,8,11.55L22.29,93.67a8.29,8.29,0,0,0-1.55,4.85Z",
    fill: "var(--primary-700)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.3fc363f44481fcef8b721ac8a577d072.svg";
export { ForwardRef as ReactComponent };